import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import {
    usePortfolioSelection,
    usePortfolioProfile,
} from "../../../shared/contexts/portfolio-context/components/PortfolioContextProvider";
import { ParameterType } from "../../options-table/types/ParameterType";

export function OptionParameterTypeSelector() {
    const {
        selectedPortfolio,
    } = usePortfolioSelection();
    const {
        updateSelectedPortfolio,
    } = usePortfolioProfile();
    
    async function handleSelection(eventArg: SelectChangeEvent<string>) {
        if (selectedPortfolio === undefined ||
            selectedPortfolio === null ||
            selectedPortfolio.portfolioSettings === null
        ) {
            return;
        }

        selectedPortfolio.portfolioSettings.selectedOptionParameterType =
            ParameterType[eventArg.target.value as keyof typeof ParameterType];
        
        await updateSelectedPortfolio();
    }
    
    return (
        <FormControl
            variant="standard"
            sx={{ width: 150}}
            size="small"
        >
            <InputLabel id="option-parameter-types-label">
                <b>Option parameter type</b>
            </InputLabel>
            <Select
                labelId="option-parameter-types-label"
                value={selectedPortfolio !== undefined && selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null && Object.values(ParameterType).includes(ParameterType[selectedPortfolio.portfolioSettings.selectedOptionParameterType])    
                    ? ParameterType[selectedPortfolio.portfolioSettings.selectedOptionParameterType]
                    : ' '}
                onChange={handleSelection}
            >
               {Object.keys(ParameterType)
                   .filter((key) => isNaN(Number(key)))
                   .map((typeName) => (
                        <MenuItem
                            key={typeName}
                            value={typeName}
                        >
                            {typeName}
                        </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}